<template>
    <h1>logging out</h1>
</template>
<script>
export default {
    name: "logout",
    data(){
        return{

        }

    },
    mounted(){
        localStorage.removeItem('user')
        localStorage.removeItem('access_token')
        localStorage.removeItem('created_by')
        localStorage.removeItem('wallet')
       this.$router.push('/login')
    }
}
</script>